import "./NoCatalogAccess.scss";
import { Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation} from "@fortawesome/pro-light-svg-icons";

export default function NoCatalogAccess(){
	function goToSelect(){
		window.location = "/catalog/select";
	}
	return(
		<div className="no-catalog-access-container">
			<div className="no-catalog-access-inner">
				<FontAwesomeIcon 
					icon={faCircleExclamation} 
					style={{
						fontSize: "30px",
						color: "red",
					}}
				/>
				<div className="error-text">
				The requested page is not available. Please return to Catalog Select, or contact the organization to verify access.
				</div>
				<Button
					className="return-button"
					onClick={goToSelect}
				>
					Return to Catalog Select
				</Button>
			</div>
			
		</div>
	)
}